import clubsConfig from '@/common/clubsConfig.js';

// 1.  Use constants for magic strings:
const VAGALUME_SLUG = 'vagalume-tulum';
const MIA_SLUG = 'mia-beach-club-tulum';
const KANAN_SLUG = 'kanan-beach-club-tulum';
const TANTRA_SLUG = 'tantra-tulum';
const MEZE_SLUG = 'meze-tulum';
const BUUTS_SLUG = 'buuts-ha-tulum';
const BAGATELLE_SLUG = 'bagatelle-tulum';
const PAPAYA_SLUG = 'papaya-playa';
const GITANO_BEACH_SLUG = 'gitano-beach-tulum';
const GITANO_SLUG= 'gitano-tulum';
const MAYAN_MONKEY_SLUG = 'mayan-monkey-tulum';
const MARTINA_SLUG = 'martina-tulum';
const BONBONNIERE_SLUG = 'bonbonniere-tulum';
const CONFESSIONS_SLUG = 'confessions-tulum';
const ROSANEGRA_BEACH_SLUG = 'rosanegra-beach-club-tulum';
const ROSANEGRA_SLUG = 'rosa-negra-tulum';
const TABOO_SLUG = 'taboo-tulum';
const ILIOS_SLUG = 'ilios-restaurant-tulum';
const AHAU_SLUG = 'ahau-tulum';
const ZAMNA_BEACH_SLUG = 'zamna-on-the-beach';
const ZAMNA_SLUG = 'zamna-tulum';
const THEMPLO_SLUG = 'tehmplo-tulum';
const VESICA_SLUG = 'vesica-tulum';
const KARMA_SLUG = 'karma-restaurant-tulum';
const CHAMBAO_SLUG = 'chambao-tulum';
const FUNKY_SLUG = 'funky-geisha-tulum';
const BESTIARIO_SLUG = 'bestiario-tulum';
const PAROLE_SLUG = 'parole-tulum';
const MAMAZZITA_SLUG = 'mamazzita-tulum';
const TORA_SLUG = 'tora-tulum';
const BAK_SLUG = 'bak-tulum';


/**
 * Extracts the venue from a slug.
 * @param {string} slug - The slug string (e.g., 'vagalume-tulum').
 * @returns {string} The venue name, or an empty string if no slug.
 */
function slugDecoder(slug) {
  return slug ? slug.split('-')[0] : '';
}

/**
 * Decodes a venue title to retrieve venue data from clubsConfig.
 * @param {string} title - The venue title string.
 * @returns {object} The corresponding venue object from clubsConfig, or an object with the original title if not found.
 */
function venueDecoder(slugOrTitle) {
  let venue = '';
  if(slugOrTitle.indexOf('@') > -1) {
    venue = slugOrTitle.split('@')[1];
  } else {
    return  clubsConfig[slugOrTitle] ;
  }

  const venueMatch = venue.toLowerCase().replace("tulum",'');
  const venueConfigMap = {
    vagalume: VAGALUME_SLUG,
    mia: MIA_SLUG,
    kanan: KANAN_SLUG,
    tantra: TANTRA_SLUG,
    meze: MEZE_SLUG,
    buuts: BUUTS_SLUG,
    bagatelle: BAGATELLE_SLUG,
    papaya: PAPAYA_SLUG,
    'gitano.+beach': GITANO_BEACH_SLUG,
    gitano: GITANO_SLUG,
    'mayan monkey': MAYAN_MONKEY_SLUG,
    bonbonniere: BONBONNIERE_SLUG,
    'confessions': CONFESSIONS_SLUG,
    'rosanegra': ROSANEGRA_BEACH_SLUG,
    'rosa.+negra': ROSANEGRA_SLUG,
    'taboo': TABOO_SLUG,
    ilios: ILIOS_SLUG,
    ahau: AHAU_SLUG,
    'zamna.+beach': ZAMNA_BEACH_SLUG,
    'zamna': ZAMNA_SLUG,
    vesica: VESICA_SLUG,
    karma: KARMA_SLUG,
    chambao: CHAMBAO_SLUG,
    bak: BAK_SLUG,
    funky: FUNKY_SLUG,
    bestiario: BESTIARIO_SLUG,
    parole: PAROLE_SLUG,
    mamazzita: MAMAZZITA_SLUG,
    tora: TORA_SLUG,
    tehmplo: THEMPLO_SLUG,
    martina: MARTINA_SLUG
  };

  for (const key in venueConfigMap) {
    if (venueMatch.match(key)) {

      // console.info('venue decoder: venue found:' + slugOrTitle + ':' + clubsConfig[venueConfigMap[key]].name );
      return clubsConfig[venueConfigMap[key]] ;
    }
  }
  console.error('venue decoder: venue not found:' + slugOrTitle );


  return { title: '', name: '', address: {} };
}



export {  venueDecoder, slugDecoder };
